var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.484 0h29.032v29.031H.484Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 3.629q4.48-.001 7.684 3.203 3.203 3.207 3.203 7.684 0 4.48-3.203 7.683Q19.48 25.403 15 25.402q-4.48.001-7.684-3.203c-2.136-2.137-3.203-4.695-3.203-7.683q0-4.478 3.203-7.684Q10.52 3.628 15 3.629M15 0Q8.988 0 4.734 4.254.485 8.509.484 14.516q.001 6.011 4.25 10.265Q8.988 29.035 15 29.035t10.266-4.254q4.249-4.254 4.25-10.265-.001-6.007-4.25-10.262Q21.012 0 15 0m4.934 16.84-3.118-3.117V7.258h-3.632v7.258q.001.795.625 1.363l3.574 3.516Zm0 0"
  }))));
};
export default SvgClock;